import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import classnames from 'classnames';

import { PasswordField } from './PasswordField';

const passwordMinLength = 7;

export default class CreatePasswordSection extends React.Component {
  static propTypes = {
    password: PropTypes.string,
  };

  getValidationFlags = () => {
    const { password } = this.props;

    return {
      invalidLength: password.length < passwordMinLength,
      noCaps: !/[A-Z]+/.test(password),
      noLowers: !/[a-z]+/.test(password),
      noDigital: !/[0-9]+/.test(password),
      noSymbols: !/[#$^&*_\-+%@]+/.test(password),
    };
  };

  render() {
    const { invalidLength, noCaps, noLowers, noDigital, noSymbols } = this.getValidationFlags();

    return (
      <div className="profile_password js-add-block">
        <h4 className="page_margin30">{'Задать пароль для входа в Личный кабинет'}</h4>

        <div className="link link_attention-red">
          {'ВНИМАНИЕ! Новый пароль обязательно должен содержать:'}
        </div>

        <ul className="list list__dark profile_list">
          <li className={classnames({ red: invalidLength })}>{'Не менее 7 символов'}</li>
          <li className={classnames({ red: noCaps })}>{'Прописные латинские буквы (A-Z)'}</li>
          <li className={classnames({ red: noLowers })}>{'Строчные латинские буквы (a-z)'}</li>
          <li className={classnames({ red: noDigital })}>{'Арабские цифры (0-9)'}</li>
          <li className={classnames({ red: noSymbols })}>{'Спецсимволы (#,$,^,&,*,_,-,+,%,@)'}</li>
        </ul>

        <div className="cRow">
          <div className="cCol cCol__33">
            <Field name="newPassword1" component={PasswordField} label="Пароль" />
          </div>

          <div className="cCol cCol__33">
            <Field
              name="newPassword2"
              component={PasswordField}
              label="Пароль повторно (для контроля)"
            />
          </div>
        </div>
      </div>
    );
  }
}
